// Data-driven blog posts (news + our playtime stats). Every post lives in
// src/posts/news.json and renders through views/NewsPost.vue, so publishing a
// post is a data change only: scripts/news/publish.sh appends to the JSON and
// the sitemap; the router, the Blog index and prerender all read the same file.

import NEWS_POSTS from '../posts/news.json';

export const SITE_ORIGIN = 'https://steamplayti.me';

export const newsPostPath = post => `/blog/${post.slug}/`;

export const newsPostUrl = post => `${SITE_ORIGIN}${newsPostPath(post)}`;

// Newest first, the order the Blog index shows.
export const newsPosts = () => [...NEWS_POSTS].sort((a, b) => b.date.localeCompare(a.date));

// Steam serves newer games' art under a content-hash path, which the standard
// URL 404s on, so publish.sh stores the real one on the game when it can.
export const postImage = post => {
    const game = post.games[0];

    if (!game) {
        return null;
    }

    return game.headerImage
        || `https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/${game.appId}/header.jpg`;
};

export const blogCard = post => ({
    slug: post.slug,
    title: post.title,
    excerpt: post.description,
    tag: post.tag,
    dateLabel: new Date(`${post.date}T00:00:00Z`).toLocaleDateString('en-US', {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC',
    }),
    path: newsPostPath(post),
    image: postImage(post),
});
